import { render, staticRenderFns } from "./data-compliance-config.vue?vue&type=template&id=35fb58ce"
import script from "./data-compliance-config.vue?vue&type=script&lang=ts"
export * from "./data-compliance-config.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports